import { useState } from "react";
import { Container, Box, TextField, Button, Typography, Link } from "@mui/material";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignup = () => {
    console.log("新規登録:", { email, password });
    // 実際はAPI呼び出し
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Box
        sx={{
          border: "1px solid #ccc",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2
        }}
      >
        <TextField
          fullWidth
          label="メールアドレス"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          fullWidth
          label="パスワード"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button variant="contained" fullWidth onClick={handleSignup}>
          OK
        </Button>
        <Typography variant="body2">
          すでにアカウントをお持ちですか？
          <Link href="/login" underline="hover">
            ログイン
          </Link>
        </Typography>
      </Box>
    </Container>
  );
}
